import React from "react";
import { Attachment, TicketMessage } from "pages/tickets/ticket.service";
import Img from "assets/images/png/gray.jpg";
import moment from "moment";
import { base64Src } from "helpers/data";
import DownloadIcon from "assets/images/svg/download.svg";

interface MessageProps {
  message: TicketMessage;
}

interface MessageAttachmentProps {
  attachment: Attachment;
}

function MessageAttachment({ attachment }: MessageAttachmentProps) {
  const isImage = /.*image.*/.test(attachment.mimeType);
  const imageRef = React.useRef<HTMLImageElement>(null);

  function handleAttachmentDownload() {
    const a = document.createElement("a");
    a.href = base64Src(attachment!.fileBase64, attachment!.mimeType);
    a.download = attachment!.fileName;
    a.click();
  }

  if (!attachment.fileBase64) return null;

  return (
    <div className="file-box">
      <button onClick={handleAttachmentDownload} className="btn-icon">
        <img className="download-btn" src={DownloadIcon} alt="download-icon" />
      </button>
      {isImage ? (
        <img
          ref={imageRef}
          width="100"
          src={base64Src(attachment.fileBase64, attachment.mimeType)}
          alt={attachment.fileName}
        />
      ) : (
        <p>{attachment.fileName}</p>
      )}
    </div>
  );
}

function Message({ message }: MessageProps) {
  if (message.isCustomerMessage)
    return (
      <div className="send">
        <div className="send-message">
          <span className="date">{moment(message.createDate).format("hh:mm") } </span>
          <span>{message.message}</span>
        </div>
        <div className="send-Image">
          <MessageAttachment attachment={message.attachment} />
        </div>
      </div>
    );
  return (
    <div className="res mb-4">
      <div className="info ">
        <img className="img" src={Img} alt="" />
        <h2 className="name">{message.senderName}</h2>
        <h3 className="time">{moment(message.createDate).format("hh:mm")}</h3>
      </div>

      <div className="send-message">
        <span>{message.message}</span>
      </div>
      <div className="send-Image">
        <MessageAttachment attachment={message.attachment} />
      </div>
    </div>
  );
}

export default Message;
